// extracted by mini-css-extract-plugin
export default {"wrap":"SideBar_wrap__U16+T","infoMenuBlock":"SideBar_infoMenuBlock__+qvvY","languageBlock":"SideBar_languageBlock__UWGJa"};